import ChargingRequestContainer from "containers/ChargingStationTable/ChargingStationRequest/index";
import React from "react";

const ChargingRequest = () => {
  return (
    <>
      <ChargingRequestContainer />
    </>
  );
};

export default ChargingRequest;